import BaseAction from './BaseAction.js';

export default class UnmapPlanarParameters extends BaseAction {
    constructor(sequencerEngine) {
        super(sequencerEngine);
    }

    // stepNumber can be a floating value, indicating
    // the unquantized offset
    // Any mutation of the step pattern for any track
    // which requires adding a step must come through here
    execute({effect, parameters}, updateRedux=true) {
        let idToGroup = {};
        for (let p of parameters) {
            if (p.hasGroup) {
                idToGroup[p.id] = p.hasGroup;
            }
            let i = effect._parameters.indexOf(p);
            effect.unmapParameter(i);
        }
        return {
            idToGroup
        };
    }

    undo({payload}) {
        let {parameters, idToGroup, effect} = payload;
        parameters.forEach(
            parameter => {
                effect.setParameter(parameter);
                if (idToGroup[parameter.id]) {
                    idToGroup[parameter.id]._parameters.push(
                        parameter);
                    parameter.hasGroup = idToGroup[parameter.id];
                }
            });
    }
}
 
